// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/images/auth3main.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-container {
  display: flex;
  height: 100vh;
  max-height: 100vh;
  position: relative;
  overflow: hidden;
}
.login-container .image-section {
  width: 60%;
  height: 100vh;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
  position: relative;
  display: flex;
  align-items: end;
  color: white;
}
.login-container .image-section .image-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 1;
}
.login-container .image-section .carousel-text {
  position: relative;
  z-index: 2;
  padding: 20px;
}
.login-container .image-section .carousel-text h1 {
  font-size: 2.8rem;
  font-weight: 700;
  margin-bottom: 12px;
  line-height: 1.2;
}
.login-container .image-section .carousel-text p {
  font-size: 1.2rem;
  max-width: 500px;
  line-height: 1.5;
}
.login-container .form-section {
  width: 40%;
  background: #fff;
  display: flex;
  position: relative;
  padding: 0;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  max-height: 100vh;
  overflow-y: auto;
}
.login-container .form-section .main-logo-log {
  width: 100%;
  display: flex;
  padding: 40px 40px 20px;
  max-width: 600px;
  justify-content: flex-start;
  flex-shrink: 0;
}
.login-container .form-section .main-logo-log .logo-dark-main-login {
  height: 8vh;
  min-height: 40px;
  max-height: 60px;
  cursor: pointer;
  transition: transform 0.2s ease;
}
.login-container .form-section .auth-form-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 20px 40px 40px;
  width: 100%;
  max-width: 600px;
  overflow-y: auto;
}
.login-container .form-section .forgot-password {
  margin-bottom: 24px;
  font-size: 14px;
}
.login-container .form-section .forgot-password .forgot-password-text {
  color: #6b7280;
}
.login-container .form-section .forgot-password .forgot-password-link {
  color: #000;
  margin-inline-start: 5px;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.2s ease;
}
.login-container .form-section .forgot-password .forgot-password-link:hover {
  text-decoration: underline;
  color: #3b5bdb;
}
.login-container .form-section .form-title {
  font-size: 28px;
  font-weight: 700;
  color: #1f2937;
  text-align: left;
  margin-bottom: 20px;
  width: 100%;
  line-height: 1.3;
}
.login-container .form-section .form-subtitle {
  display: none;
}
.login-container .form-section .mode-tabs {
  display: flex;
  width: 100%;
  margin-bottom: 32px;
  border-bottom: 1px solid #e5e7eb;
  overflow: hidden;
}
.login-container .form-section .mode-tabs .mode-tab {
  flex: 1 1;
  padding: 16px 0;
  border: none;
  background: none;
  color: #6b7280;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  position: relative;
  transition: all 0.2s ease;
  white-space: nowrap;
}
.login-container .form-section .mode-tabs .mode-tab:hover {
  color: #374151;
}
.login-container .form-section .mode-tabs .mode-tab.active {
  color: #000;
}
.login-container .form-section .mode-tabs .mode-tab.active::after {
  content: "";
  position: absolute;
  bottom: -1px;
  left: 0;
  right: 0;
  height: 2px;
  background: #000;
}
.login-container .form-section .auth-form {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.login-container .form-section .auth-form .input-section .input-label {
  display: block;
  margin-bottom: 8px;
}
.login-container .form-section .auth-form .input-section .input-label .label-text {
  display: inline-flex;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
  color: #4b5563;
  padding: 0;
}
.login-container .form-section .auth-form .input-section .input-container {
  display: flex;
  align-items: center;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  overflow: visible;
  background: white;
  position: relative;
  min-height: 50px;
  transition: border-color 0.2s ease;
  gap: 8px;
}
.login-container .form-section .auth-form .input-section .input-container:focus-within {
  border-color: #000;
  box-shadow: 0 0 0 1px #000;
}
.login-container .form-section .auth-form .input-section .input-container .country-code {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 16px;
  background: #f9fafb;
  border-right: 1px solid #d1d5db;
  gap: 8px;
  font-size: 14px;
  color: #374151;
  font-weight: 500;
  min-width: 80px;
  text-align: center;
  white-space: nowrap;
}
.login-container .form-section .auth-form .input-section .input-container .country-code .flag {
  font-size: 16px;
  line-height: 1;
}
.login-container .form-section .auth-form .input-section .input-container .input-field {
  flex: 1 1;
  border: none;
  padding: 12px 16px;
  font-size: 16px;
  color: #1f2937;
  background: transparent;
  min-width: 0;
  transition: all 0.2s ease;
}
.login-container .form-section .auth-form .input-section .input-container .input-field:focus {
  outline: none;
}
.login-container .form-section .auth-form .input-section .input-container .input-field::placeholder {
  color: #9ca3af;
}
.login-container .form-section .auth-form .input-section .input-container .input-field:disabled {
  background-color: #f9fafb;
  cursor: not-allowed;
  color: #6b7280;
  opacity: 0.9;
}
.login-container .form-section .auth-form .input-section .input-container .edit-contact-btn {
  background: none;
  border: none;
  padding: 8px;
  cursor: pointer;
  color: #6b7280;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  transition: all 0.2s ease;
  flex-shrink: 0;
  margin-right: 4px;
  animation: fadeInScale 0.2s ease-out;
}
.login-container .form-section .auth-form .input-section .input-container .edit-contact-btn:hover {
  background-color: #f3f4f6;
  color: #374151;
}
.login-container .form-section .auth-form .input-section .input-container .edit-contact-btn:active {
  transform: scale(0.95);
}
.login-container .form-section .auth-form .input-section .input-container .edit-contact-btn svg {
  width: 18px;
  height: 18px;
}
.login-container .form-section .auth-form .input-section .input-container .resend-otp-btn {
  background: #3b5bdb;
  color: white;
  border: none;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease;
  white-space: nowrap;
  flex-shrink: 0;
  margin-right: 8px;
}
.login-container .form-section .auth-form .input-section .input-container .resend-otp-btn:hover:not(:disabled) {
  background: #3B435F;
}
.login-container .form-section .auth-form .input-section .input-container .resend-otp-btn:disabled {
  background: #cbd5e1;
  cursor: not-allowed;
}
.login-container .form-section .auth-form .input-section .input-container:has(.edit-contact-btn) .input-field {
  padding-right: 8px;
}
.login-container .form-section .auth-form .otp-input-section {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.login-container .form-section .auth-form .otp-input-section .input-label {
  display: block;
  margin-bottom: 0;
}
.login-container .form-section .auth-form .otp-input-section .input-label .label-text {
  display: inline-flex;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
  color: #4b5563;
  padding: 0;
}
.login-container .form-section .auth-form .otp-input-section .otp-boxes {
  display: flex;
  gap: 8px;
  justify-content: space-between;
}
.login-container .form-section .auth-form .otp-input-section .otp-boxes .otp-input {
  width: 48px;
  height: 50px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
  flex: 1 1;
  max-width: 60px;
  transition: border-color 0.2s ease;
}
.login-container .form-section .auth-form .otp-input-section .otp-boxes .otp-input:focus {
  outline: none;
  border-color: #000;
  box-shadow: 0 0 0 1px #000;
}
.login-container .form-section .auth-form .error-message {
  background: #fef2f2;
  color: #dc2626;
  padding: 12px 16px;
  border-radius: 8px;
  font-size: 14px;
  border: 1px solid #fecaca;
  text-align: center;
  animation: slideIn 0.3s ease-out;
}
@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes fadeInScale {
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
.login-container .form-section .auth-form .send-otp-btn {
  width: 100%;
  background: #1f2937;
  color: white;
  border: none;
  padding: 16px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease;
  min-height: 50px;
}
.login-container .form-section .auth-form .send-otp-btn:hover:not(:disabled) {
  background: #111827;
}
.login-container .form-section .auth-form .send-otp-btn:disabled {
  background: #cbd5e1;
  cursor: not-allowed;
}
.login-container .form-section .auth-form .auth-divider {
  display: flex;
  align-items: center;
  color: #9ca3af;
  font-size: 14px;
  margin: 8px 0;
}
.login-container .form-section .auth-form .auth-divider::before, .login-container .form-section .auth-form .auth-divider::after {
  content: "";
  flex: 1 1;
  height: 1px;
  background: #e5e7eb;
}
.login-container .form-section .auth-form .auth-divider span {
  padding: 0 16px;
}
.login-container .form-section .auth-form .social-buttons {
  display: flex;
  justify-content: center;
  gap: 20px;
  width: 100%;
}
.login-container .form-section .auth-form .social-buttons .social-btn {
  flex: 1 1;
  height: 52px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  background: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  font-size: 16px;
  font-weight: 500;
  color: #374151;
}
.login-container .form-section .auth-form .social-buttons .social-btn:hover {
  background-color: #f9fafb;
}
.login-container .form-section .auth-form .social-buttons .social-btn::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
  transition: left 0.5s ease;
}
.login-container .form-section .auth-form .social-buttons .social-btn:hover::before {
  left: 100%;
}
.login-container .form-section .auth-form .social-buttons .social-btn img {
  width: 24px;
  height: 24px;
  transition: transform 0.3s ease;
}
.login-container .form-section .auth-form .social-buttons .social-btn:hover img {
  transform: scale(1.05);
}
@media (max-width: 1024px) {
  .login-container .image-section {
    width: 50%;
  }
  .login-container .image-section .carousel-text h1 {
    font-size: 2.4rem;
  }
  .login-container .image-section .carousel-text p {
    font-size: 1.1rem;
  }
  .login-container .form-section {
    width: 50%;
  }
  .login-container .form-section .auth-form-content {
    padding: 30px;
  }
  .login-container .form-section .form-title {
    font-size: 24px;
  }
}
@media (max-width: 1024px) and (max-height: 600px) {
  .login-container .image-section {
    width: 45%;
  }
  .login-container .image-section .carousel-text {
    padding: 15px;
  }
  .login-container .image-section .carousel-text h1 {
    font-size: 1.8rem;
    margin-bottom: 8px;
  }
  .login-container .image-section .carousel-text p {
    font-size: 0.95rem;
    max-width: 400px;
  }
  .login-container .form-section {
    width: 55%;
  }
  .login-container .form-section .main-logo-log {
    padding: 15px 30px 10px;
  }
  .login-container .form-section .main-logo-log .logo-dark-main-login {
    height: 5vh;
    min-height: 25px;
    max-height: 40px;
  }
  .login-container .form-section .auth-form-content {
    padding: 10px 30px 20px;
  }
  .login-container .form-section .form-title {
    font-size: 20px;
    margin-bottom: 12px;
  }
  .login-container .form-section .forgot-password {
    margin-bottom: 16px;
    font-size: 12px;
  }
  .login-container .form-section .mode-tabs {
    margin-bottom: 20px;
  }
  .login-container .form-section .mode-tabs .mode-tab {
    padding: 10px 0;
    font-size: 12px;
  }
  .login-container .form-section .auth-form {
    gap: 16px;
  }
  .login-container .form-section .auth-form .input-section .input-container {
    min-height: 42px;
  }
  .login-container .form-section .auth-form .input-section .input-container .country-code {
    padding: 8px 12px;
    font-size: 12px;
  }
  .login-container .form-section .auth-form .input-section .input-container .input-field {
    padding: 8px 12px;
    font-size: 14px;
  }
  .login-container .form-section .auth-form .input-section .input-container .edit-contact-btn {
    padding: 6px;
  }
  .login-container .form-section .auth-form .input-section .input-container .edit-contact-btn svg {
    width: 16px;
    height: 16px;
  }
  .login-container .form-section .auth-form .input-section .input-container .resend-otp-btn {
    font-size: 11px;
    padding: 6px 10px;
  }
  .login-container .form-section .auth-form .otp-input-section .otp-boxes .otp-input {
    width: 38px;
    height: 42px;
    font-size: 16px;
    max-width: 50px;
  }
  .login-container .form-section .auth-form .send-otp-btn {
    padding: 12px;
    font-size: 14px;
    min-height: 42px;
  }
}
@media (max-width: 850px) {
  .login-container {
    flex-direction: column;
    height: 100vh;
    max-height: 100vh;
  }
  .login-container .image-section {
    width: 100%;
    height: 40vh;
    max-height: 40vh;
    order: -1;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
  }
  .login-container .image-section .carousel-text h1 {
    font-size: 2rem;
    margin-bottom: 8px;
  }
  .login-container .image-section .carousel-text p {
    font-size: 1rem;
    text-align: center;
  }
  .login-container .form-section {
    width: 100%;
    height: 60vh;
    max-height: 60vh;
    justify-content: flex-start;
    padding-top: 0;
    overflow-y: auto;
  }
  .login-container .form-section .main-logo-log {
    padding: 15px 30px 8px;
    flex-shrink: 0;
  }
  .login-container .form-section .main-logo-log .logo-dark-main-login {
    height: 5vh;
    min-height: 30px;
    max-height: 45px;
  }
  .login-container .form-section .auth-form-content {
    padding: 8px 30px 20px;
    flex: 1 1;
    overflow-y: auto;
  }
  .login-container .form-section .form-title {
    font-size: 22px;
    margin-bottom: 12px;
  }
  .login-container .form-section .mode-tabs {
    margin-bottom: 20px;
  }
  .login-container .form-section .mode-tabs .mode-tab {
    padding: 12px 0;
    font-size: 13px;
  }
  .login-container .form-section .auth-form {
    gap: 16px;
  }
  .login-container .form-section .auth-form .input-section .input-container .edit-contact-btn {
    padding: 7px;
  }
  .login-container .form-section .auth-form .input-section .input-container .edit-contact-btn svg {
    width: 17px;
    height: 17px;
  }
  .login-container .form-section .auth-form .input-section .input-container .resend-otp-btn {
    font-size: 12px;
    padding: 8px 12px;
  }
  .login-container .form-section .auth-form .otp-input-section .otp-boxes .otp-input {
    width: auto;
    min-width: 40px;
    max-width: none;
    flex: 1 1;
    height: 48px;
    font-size: 16px;
  }
  .login-container .form-section .auth-form .social-buttons {
    flex-direction: column;
    gap: 12px;
  }
  .login-container .form-section .auth-form .social-buttons .social-btn {
    height: 48px;
  }
}
@media (max-width: 480px) {
  .login-container .image-section {
    height: 35vh;
    max-height: 35vh;
    min-height: 180px;
  }
  .login-container .image-section .carousel-text {
    padding: 10px;
    text-align: center;
  }
  .login-container .image-section .carousel-text h1 {
    font-size: 1.6rem;
    margin-bottom: 6px;
  }
  .login-container .image-section .carousel-text p {
    font-size: 0.9rem;
    max-width: 300px;
  }
  .login-container .form-section {
    height: 65vh;
    max-height: 65vh;
  }
  .login-container .form-section .main-logo-log {
    padding: 10px 20px 5px;
  }
  .login-container .form-section .main-logo-log .logo-dark-main-login {
    height: 4vh;
    min-height: 28px;
    max-height: 40px;
  }
  .login-container .form-section .auth-form-content {
    padding: 5px 20px 15px;
  }
  .login-container .form-section .form-title {
    font-size: 20px;
    margin-bottom: 10px;
  }
  .login-container .form-section .forgot-password {
    margin-bottom: 14px;
    font-size: 13px;
  }
  .login-container .form-section .mode-tabs {
    margin-bottom: 16px;
  }
  .login-container .form-section .mode-tabs .mode-tab {
    padding: 10px 0;
    font-size: 12px;
  }
  .login-container .form-section .auth-form {
    gap: 14px;
  }
  .login-container .form-section .auth-form .input-section .input-container {
    min-height: 48px;
  }
  .login-container .form-section .auth-form .input-section .input-container .country-code {
    padding: 10px 12px;
    min-width: 70px;
    font-size: 13px;
  }
  .login-container .form-section .auth-form .input-section .input-container .input-field {
    padding: 10px 12px;
    font-size: 16px;
  }
  .login-container .form-section .auth-form .input-section .input-container .edit-contact-btn {
    padding: 8px;
  }
  .login-container .form-section .auth-form .input-section .input-container .edit-contact-btn svg {
    width: 18px;
    height: 18px;
  }
  .login-container .form-section .auth-form .input-section .input-container .resend-otp-btn {
    font-size: 11px;
    padding: 6px 10px;
  }
  .login-container .form-section .auth-form .otp-input-section .otp-boxes {
    gap: 6px;
  }
  .login-container .form-section .auth-form .otp-input-section .otp-boxes .otp-input {
    height: 46px;
    font-size: 16px;
    min-width: 36px;
  }
  .login-container .form-section .auth-form .send-otp-btn {
    padding: 14px;
    font-size: 15px;
    min-height: 48px;
  }
}
@media (max-width: 320px) {
  .login-container .image-section {
    height: 30vh;
    max-height: 30vh;
    min-height: 150px;
  }
  .login-container .image-section .carousel-text h1 {
    font-size: 1.4rem;
  }
  .login-container .image-section .carousel-text p {
    font-size: 0.8rem;
    max-width: 250px;
  }
  .login-container .form-section {
    height: 70vh;
    max-height: 70vh;
  }
  .login-container .form-section .main-logo-log {
    padding: 8px 15px;
  }
  .login-container .form-section .main-logo-log .logo-dark-main-login {
    height: 3vh;
    min-height: 24px;
    max-height: 35px;
  }
  .login-container .form-section .auth-form-content {
    padding: 4px 15px 12px;
  }
  .login-container .form-section .form-title {
    font-size: 18px;
    margin-bottom: 8px;
  }
  .login-container .form-section .auth-form {
    gap: 12px;
  }
  .login-container .form-section .auth-form .input-section .input-container .country-code {
    padding: 8px 10px;
    min-width: 65px;
    font-size: 12px;
  }
  .login-container .form-section .auth-form .input-section .input-container .input-field {
    padding: 8px 10px;
  }
  .login-container .form-section .auth-form .input-section .input-container .edit-contact-btn {
    padding: 6px;
  }
  .login-container .form-section .auth-form .input-section .input-container .edit-contact-btn svg {
    width: 16px;
    height: 16px;
  }
  .login-container .form-section .auth-form .input-section .input-container .resend-otp-btn {
    font-size: 10px;
    padding: 5px 8px;
  }
  .login-container .form-section .auth-form .otp-input-section .otp-boxes {
    gap: 4px;
  }
  .login-container .form-section .auth-form .otp-input-section .otp-boxes .otp-input {
    min-width: 32px;
    height: 44px;
    font-size: 15px;
  }
}
@media (min-resolution: 192dpi) {
  .login-container .form-section .main-logo-log .logo-dark-main-login {
    image-rendering: -webkit-optimize-contrast;
  }
}
@media (prefers-reduced-motion: reduce) {
  .login-container *,
  .login-container *::before,
  .login-container *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}
@media print {
  .login-container .image-section {
    display: none;
  }
  .login-container .form-section {
    width: 100%;
    box-shadow: none;
    background: white;
  }
}`, "",{"version":3,"sources":["webpack://./src/auth/auth.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;AACF;AACE;EACE,UAAA;EACA,aAAA;EACA,yDAAA;EACA,sBAAA;EACA,2BAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,YAAA;AACJ;AACI;EACE,kBAAA;EACA,QAAA;EACA,8BAAA;EACA,UAAA;AACN;AAEI;EACE,kBAAA;EACA,UAAA;EACA,aAAA;AAAN;AAEM;EACE,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AAAR;AAGM;EACE,iBAAA;EACA,gBAAA;EACA,gBAAA;AADR;AAOE;EACE,UAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,iBAAA;EACA,gBAAA;AALJ;AAOI;EACE,WAAA;EACA,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,2BAAA;EACA,cAAA;AALN;AAOM;EACE,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,+BAAA;AALR;AASI;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;AAPN;AAUI;EACE,mBAAA;EACA,eAAA;AARN;AAUM;EACE,cAAA;AARR;AAWM;EACE,WAAA;EACA,wBAAA;EACA,qBAAA;EACA,gBAAA;EACA,2BAAA;AATR;AAWQ;EACE,0BAAA;EACA,cAAA;AATV;AAcI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;AAZN;AAeI;EACE,aAAA;AAbN;AAgBI;EACE,aAAA;EACA,WAAA;EACA,mBAAA;EACA,gCAAA;EACA,gBAAA;AAdN;AAgBM;EACE,SAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;AAdR;AAgBQ;EACE,cAAA;AAdV;AAiBQ;EACE,WAAA;AAfV;AAiBU;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,gBAAA;AAfZ;AAqBI;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAnBN;AAsBQ;EACE,cAAA;EACA,kBAAA;AApBV;AAsBU;EACE,oBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,UAAA;AApBZ;AAwBQ;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kCAAA;EACA,QAAA;AAtBV;AAwBU;EACE,kBAAA;EACA,0BAAA;AAtBZ;AAyBU;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;EACA,+BAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;AAvBZ;AAyBY;EACE,eAAA;EACA,cAAA;AAvBd;AA2BU;EACE,SAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,uBAAA;EACA,YAAA;EACA,yBAAA;AAzBZ;AA2BY;EACE,aAAA;AAzBd;AA4BY;EACE,cAAA;AA1Bd;AA6BY;EACE,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,YAAA;AA3Bd;AAgCU;EACE,gBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;EACA,iBAAA;EACA,oCAAA;AA9BZ;AAgCY;EACE,yBAAA;EACA,cAAA;AA9Bd;AAiCY;EACE,sBAAA;AA/Bd;AAkCY;EACE,WAAA;EACA,YAAA;AAhCd;AAoCU;EACE,mBAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,sCAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;AAlCZ;AAoCY;EACE,mBAAA;AAlCd;AAqCY;EACE,mBAAA;EACA,mBAAA;AAnCd;AAyCY;EACE,kBAAA;AAvCd;AA6CM;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AA3CR;AA6CQ;EACE,cAAA;EACA,gBAAA;AA3CV;AA6CU;EACE,oBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,UAAA;AA3CZ;AA+CQ;EACE,aAAA;EACA,QAAA;EACA,8BAAA;AA7CV;AA+CU;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;EACA,eAAA;EACA,kCAAA;AA7CZ;AA+CY;EACE,aAAA;EACA,kBAAA;EACA,0BAAA;AA7Cd;AAmDM;EACE,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,gCAAA;AAjDR;AAoDM;EACE;IACE,UAAA;IACA,4BAAA;EAlDR;EAqDM;IACE,UAAA;IACA,wBAAA;EAnDR;AACF;AAsDM;EACE;IACE,UAAA;IACA,qBAAA;EApDR;EAsDM;IACE,UAAA;IACA,mBAAA;EApDR;AACF;AAuDM;EACE,WAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,sCAAA;EACA,gBAAA;AArDR;AAuDQ;EACE,mBAAA;AArDV;AAwDQ;EACE,mBAAA;EACA,mBAAA;AAtDV;AA0DM;EACE,aAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;AAxDR;AA0DQ;EAEE,WAAA;EACA,SAAA;EACA,WAAA;EACA,mBAAA;AAzDV;AA4DQ;EACE,eAAA;AA1DV;AA8DM;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,WAAA;AA5DR;AA8DQ;EACE,SAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AA5DV;AA8DU;EACE,yBAAA;AA5DZ;AA+DU;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,sFAAA;EACA,0BAAA;AA7DZ;AAgEU;EACE,UAAA;AA9DZ;AAiEU;EACE,WAAA;EACA,YAAA;EACA,+BAAA;AA/DZ;AAkEU;EACE,sBAAA;AAhEZ;AAwEE;EACE;IACE,UAAA;EAtEJ;EAyEM;IACE,iBAAA;EAvER;EA0EM;IACE,iBAAA;EAxER;EA6EE;IACE,UAAA;EA3EJ;EA6EI;IACE,aAAA;EA3EN;EA8EI;IACE,eAAA;EA5EN;AACF;AAiFE;EACE;IACE,UAAA;EA/EJ;EAiFI;IACE,aAAA;EA/EN;EAiFM;IACE,iBAAA;IACA,kBAAA;EA/ER;EAkFM;IACE,kBAAA;IACA,gBAAA;EAhFR;EAqFE;IACE,UAAA;EAnFJ;EAqFI;IACE,uBAAA;EAnFN;EAqFM;IACE,WAAA;IACA,gBAAA;IACA,gBAAA;EAnFR;EAuFI;IACE,uBAAA;EArFN;EAwFI;IACE,eAAA;IACA,mBAAA;EAtFN;EAyFI;IACE,mBAAA;IACA,eAAA;EAvFN;EA0FI;IACE,mBAAA;EAxFN;EA0FM;IACE,eAAA;IACA,eAAA;EAxFR;EA4FI;IACE,SAAA;EA1FN;EA6FQ;IACE,gBAAA;EA3FV;EA6FU;IACE,iBAAA;IACA,eAAA;EA3FZ;EA8FU;IACE,iBAAA;IACA,eAAA;EA5FZ;EA+FU;IACE,YAAA;EA7FZ;EA+FY;IACE,WAAA;IACA,YAAA;EA7Fd;EAiGU;IACE,eAAA;IACA,iBAAA;EA/FZ;EAsGU;IACE,WAAA;IACA,YAAA;IACA,eAAA;IACA,eAAA;EApGZ;EAyGM;IACE,aAAA;IACA,eAAA;IACA,gBAAA;EAvGR;AACF;AA6GE;EAtnBF;IAunBI,sBAAA;IACA,aAAA;IACA,iBAAA;EA1GF;EA4GE;IACE,WAAA;IACA,YAAA;IACA,gBAAA;IACA,SAAA;IACA,aAAA;IACA,uBAAA;IACA,mBAAA;IACA,cAAA;EA1GJ;EA6GM;IACE,eAAA;IACA,kBAAA;EA3GR;EA8GM;IACE,eAAA;IACA,kBAAA;EA5GR;EAiHE;IACE,WAAA;IACA,YAAA;IACA,gBAAA;IACA,2BAAA;IACA,cAAA;IACA,gBAAA;EA/GJ;EAiHI;IACE,sBAAA;IACA,cAAA;EA/GN;EAiHM;IACE,WAAA;IACA,gBAAA;IACA,gBAAA;EA/GR;EAmHI;IACE,sBAAA;IACA,SAAA;IACA,gBAAA;EAjHN;EAoHI;IACE,eAAA;IACA,mBAAA;EAlHN;EAqHI;IACE,mBAAA;EAnHN;EAqHM;IACE,eAAA;IACA,eAAA;EAnHR;EAuHI;IACE,SAAA;EArHN;EAyHU;IACE,YAAA;EAvHZ;EAyHY;IACE,WAAA;IACA,YAAA;EAvHd;EA2HU;IACE,eAAA;IACA,iBAAA;EAzHZ;EAgIU;IACE,WAAA;IACA,eAAA;IACA,eAAA;IACA,SAAA;IACA,YAAA;IACA,eAAA;EA9HZ;EAmIM;IACE,sBAAA;IACA,SAAA;EAjIR;EAmIQ;IACE,YAAA;EAjIV;AACF;AAwIE;EACE;IACE,YAAA;IACA,gBAAA;IACA,iBAAA;EAtIJ;EAwII;IACE,aAAA;IACA,kBAAA;EAtIN;EAwIM;IACE,iBAAA;IACA,kBAAA;EAtIR;EAyIM;IACE,iBAAA;IACA,gBAAA;EAvIR;EA4IE;IACE,YAAA;IACA,gBAAA;EA1IJ;EA4II;IACE,sBAAA;EA1IN;EA4IM;IACE,WAAA;IACA,gBAAA;IACA,gBAAA;EA1IR;EA8II;IACE,sBAAA;EA5IN;EA+II;IACE,eAAA;IACA,mBAAA;EA7IN;EAgJI;IACE,mBAAA;IACA,eAAA;EA9IN;EAiJI;IACE,mBAAA;EA/IN;EAiJM;IACE,eAAA;IACA,eAAA;EA/IR;EAmJI;IACE,SAAA;EAjJN;EAoJQ;IACE,gBAAA;EAlJV;EAoJU;IACE,kBAAA;IACA,eAAA;IACA,eAAA;EAlJZ;EAqJU;IACE,kBAAA;IACA,eAAA;EAnJZ;EAsJU;IACE,YAAA;EApJZ;EAsJY;IACE,WAAA;IACA,YAAA;EApJd;EAwJU;IACE,eAAA;IACA,iBAAA;EAtJZ;EA4JQ;IACE,QAAA;EA1JV;EA4JU;IACE,YAAA;IACA,eAAA;IACA,eAAA;EA1JZ;EA+JM;IACE,aAAA;IACA,eAAA;IACA,gBAAA;EA7JR;AACF;AAmKE;EACE;IACE,YAAA;IACA,gBAAA;IACA,iBAAA;EAjKJ;EAoKM;IACE,iBAAA;EAlKR;EAqKM;IACE,iBAAA;IACA,gBAAA;EAnKR;EAwKE;IACE,YAAA;IACA,gBAAA;EAtKJ;EAwKI;IACE,iBAAA;EAtKN;EAwKM;IACE,WAAA;IACA,gBAAA;IACA,gBAAA;EAtKR;EA0KI;IACE,sBAAA;EAxKN;EA2KI;IACE,eAAA;IACA,kBAAA;EAzKN;EA4KI;IACE,SAAA;EA1KN;EA8KU;IACE,iBAAA;IACA,eAAA;IACA,eAAA;EA5KZ;EA+KU;IACE,iBAAA;EA7KZ;EAgLU;IACE,YAAA;EA9KZ;EAgLY;IACE,WAAA;IACA,YAAA;EA9Kd;EAkLU;IACE,eAAA;IACA,gBAAA;EAhLZ;EAsLQ;IACE,QAAA;EApLV;EAsLU;IACE,eAAA;IACA,YAAA;IACA,eAAA;EApLZ;AACF;AA4LE;EAIM;IACE,0CAAA;EA7LR;AACF;AAwME;EAEE;;;IAGE,qCAAA;IACA,uCAAA;IACA,sCAAA;EAvMJ;AACF;AA2ME;EACE;IACE,aAAA;EAzMJ;EA4ME;IACE,WAAA;IACA,gBAAA;IACA,iBAAA;EA1MJ;AACF","sourcesContent":[".login-container {\r\n  display: flex;\r\n  height: 100vh;\r\n  max-height: 100vh;\r\n  position: relative;\r\n  overflow: hidden;\r\n\r\n  .image-section {\r\n    width: 60%;\r\n    height: 100vh;\r\n    background-image: url(\"../assets/images/auth3main.jpg\");\r\n    background-size: cover;\r\n    background-position: center;\r\n    position: relative;\r\n    display: flex;\r\n    align-items: end;\r\n    color: white;\r\n\r\n    .image-overlay {\r\n      position: absolute;\r\n      inset: 0;\r\n      background: rgba(0, 0, 0, 0.4);\r\n      z-index: 1;\r\n    }\r\n\r\n    .carousel-text {\r\n      position: relative;\r\n      z-index: 2;\r\n      padding: 20px;\r\n\r\n      h1 {\r\n        font-size: 2.8rem;\r\n        font-weight: 700;\r\n        margin-bottom: 12px;\r\n        line-height: 1.2;\r\n      }\r\n\r\n      p {\r\n        font-size: 1.2rem;\r\n        max-width: 500px;\r\n        line-height: 1.5;\r\n      }\r\n    }\r\n  }\r\n\r\n  // Form section\r\n  .form-section {\r\n    width: 40%;\r\n    background: #fff;\r\n    display: flex;\r\n    position: relative;\r\n    padding: 0;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n    height: 100vh;\r\n    max-height: 100vh;\r\n    overflow-y: auto;\r\n\r\n    .main-logo-log {\r\n      width: 100%;\r\n      display: flex;\r\n      padding: 40px 40px 20px;\r\n      max-width: 600px;\r\n      justify-content: flex-start;\r\n      flex-shrink: 0;\r\n\r\n      .logo-dark-main-login {\r\n        height: 8vh;\r\n        min-height: 40px;\r\n        max-height: 60px;\r\n        cursor: pointer;\r\n        transition: transform 0.2s ease;\r\n      }\r\n    }\r\n\r\n    .auth-form-content {\r\n      display: flex;\r\n      flex-direction: column;\r\n      justify-content: center;\r\n      padding: 20px 40px 40px;\r\n      width: 100%;\r\n      max-width: 600px;\r\n      overflow-y: auto;\r\n    }\r\n\r\n    .forgot-password {\r\n      margin-bottom: 24px;\r\n      font-size: 14px;\r\n\r\n      .forgot-password-text {\r\n        color: #6b7280;\r\n      }\r\n\r\n      .forgot-password-link {\r\n        color: #000;\r\n        margin-inline-start: 5px;\r\n        text-decoration: none;\r\n        font-weight: 500;\r\n        transition: color 0.2s ease;\r\n\r\n        &:hover {\r\n          text-decoration: underline;\r\n          color: #3b5bdb;\r\n        }\r\n      }\r\n    }\r\n\r\n    .form-title {\r\n      font-size: 28px;\r\n      font-weight: 700;\r\n      color: #1f2937;\r\n      text-align: left;\r\n      margin-bottom: 20px;\r\n      width: 100%;\r\n      line-height: 1.3;\r\n    }\r\n\r\n    .form-subtitle {\r\n      display: none;\r\n    }\r\n\r\n    .mode-tabs {\r\n      display: flex;\r\n      width: 100%;\r\n      margin-bottom: 32px;\r\n      border-bottom: 1px solid #e5e7eb;\r\n      overflow: hidden;\r\n\r\n      .mode-tab {\r\n        flex: 1;\r\n        padding: 16px 0;\r\n        border: none;\r\n        background: none;\r\n        color: #6b7280;\r\n        font-size: 14px;\r\n        font-weight: 500;\r\n        cursor: pointer;\r\n        position: relative;\r\n        transition: all 0.2s ease;\r\n        white-space: nowrap;\r\n\r\n        &:hover {\r\n          color: #374151;\r\n        }\r\n\r\n        &.active {\r\n          color: #000;\r\n\r\n          &::after {\r\n            content: '';\r\n            position: absolute;\r\n            bottom: -1px;\r\n            left: 0;\r\n            right: 0;\r\n            height: 2px;\r\n            background: #000;\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n    .auth-form {\r\n      width: 100%;\r\n      display: flex;\r\n      flex-direction: column;\r\n      gap: 24px;\r\n\r\n      .input-section {\r\n        .input-label {\r\n          display: block;\r\n          margin-bottom: 8px;\r\n\r\n          .label-text {\r\n            display: inline-flex;\r\n            align-items: center;\r\n            font-size: 14px;\r\n            font-weight: 500;\r\n            color: #4b5563;\r\n            padding: 0;\r\n          }\r\n        }\r\n\r\n        .input-container {\r\n          display: flex;\r\n          align-items: center;\r\n          border: 1px solid #d1d5db;\r\n          border-radius: 8px;\r\n          overflow: visible;\r\n          background: white;\r\n          position: relative;\r\n          min-height: 50px;\r\n          transition: border-color 0.2s ease;\r\n          gap: 8px;\r\n\r\n          &:focus-within {\r\n            border-color: #000;\r\n            box-shadow: 0 0 0 1px #000;\r\n          }\r\n\r\n          .country-code {\r\n            display: flex;\r\n            align-items: center;\r\n            justify-content: center;\r\n            padding: 12px 16px;\r\n            background: #f9fafb;\r\n            border-right: 1px solid #d1d5db;\r\n            gap: 8px;\r\n            font-size: 14px;\r\n            color: #374151;\r\n            font-weight: 500;\r\n            min-width: 80px;\r\n            text-align: center;\r\n            white-space: nowrap;\r\n\r\n            .flag {\r\n              font-size: 16px;\r\n              line-height: 1;\r\n            }\r\n          }\r\n\r\n          .input-field {\r\n            flex: 1;\r\n            border: none;\r\n            padding: 12px 16px;\r\n            font-size: 16px;\r\n            color: #1f2937;\r\n            background: transparent;\r\n            min-width: 0;\r\n            transition: all 0.2s ease;\r\n\r\n            &:focus {\r\n              outline: none;\r\n            }\r\n\r\n            &::placeholder {\r\n              color: #9ca3af;\r\n            }\r\n\r\n            &:disabled {\r\n              background-color: #f9fafb;\r\n              cursor: not-allowed;\r\n              color: #6b7280;\r\n              opacity: 0.9;\r\n            }\r\n          }\r\n\r\n          // Edit button styles\r\n          .edit-contact-btn {\r\n            background: none;\r\n            border: none;\r\n            padding: 8px;\r\n            cursor: pointer;\r\n            color: #6b7280;\r\n            display: flex;\r\n            align-items: center;\r\n            justify-content: center;\r\n            border-radius: 6px;\r\n            transition: all 0.2s ease;\r\n            flex-shrink: 0;\r\n            margin-right: 4px;\r\n            animation: fadeInScale 0.2s ease-out;\r\n\r\n            &:hover {\r\n              background-color: #f3f4f6;\r\n              color: #374151;\r\n            }\r\n\r\n            &:active {\r\n              transform: scale(0.95);\r\n            }\r\n\r\n            svg {\r\n              width: 18px;\r\n              height: 18px;\r\n            }\r\n          }\r\n\r\n          .resend-otp-btn {\r\n            background: #3b5bdb;\r\n            color: white;\r\n            border: none;\r\n            padding: 8px 12px;\r\n            border-radius: 6px;\r\n            font-size: 12px;\r\n            font-weight: 600;\r\n            cursor: pointer;\r\n            transition: background-color 0.2s ease;\r\n            white-space: nowrap;\r\n            flex-shrink: 0;\r\n            margin-right: 8px;\r\n\r\n            &:hover:not(:disabled) {\r\n              background: #3B435F;\r\n            }\r\n\r\n            &:disabled {\r\n              background: #cbd5e1;\r\n              cursor: not-allowed;\r\n            }\r\n          }\r\n\r\n          // Adjust input padding when edit button is present\r\n          &:has(.edit-contact-btn) {\r\n            .input-field {\r\n              padding-right: 8px;\r\n            }\r\n          }\r\n        }\r\n      }\r\n\r\n      .otp-input-section {\r\n        display: flex;\r\n        flex-direction: column;\r\n        gap: 8px;\r\n\r\n        .input-label {\r\n          display: block;\r\n          margin-bottom: 0;\r\n\r\n          .label-text {\r\n            display: inline-flex;\r\n            align-items: center;\r\n            font-size: 14px;\r\n            font-weight: 500;\r\n            color: #4b5563;\r\n            padding: 0;\r\n          }\r\n        }\r\n\r\n        .otp-boxes {\r\n          display: flex;\r\n          gap: 8px;\r\n          justify-content: space-between;\r\n\r\n          .otp-input {\r\n            width: 48px;\r\n            height: 50px;\r\n            border: 1px solid #d1d5db;\r\n            border-radius: 8px;\r\n            text-align: center;\r\n            font-size: 18px;\r\n            font-weight: 600;\r\n            color: #1f2937;\r\n            flex: 1;\r\n            max-width: 60px;\r\n            transition: border-color 0.2s ease;\r\n\r\n            &:focus {\r\n              outline: none;\r\n              border-color: #000;\r\n              box-shadow: 0 0 0 1px #000;\r\n            }\r\n          }\r\n        }\r\n      }\r\n\r\n      .error-message {\r\n        background: #fef2f2;\r\n        color: #dc2626;\r\n        padding: 12px 16px;\r\n        border-radius: 8px;\r\n        font-size: 14px;\r\n        border: 1px solid #fecaca;\r\n        text-align: center;\r\n        animation: slideIn 0.3s ease-out;\r\n      }\r\n\r\n      @keyframes slideIn {\r\n        from {\r\n          opacity: 0;\r\n          transform: translateY(-10px);\r\n        }\r\n\r\n        to {\r\n          opacity: 1;\r\n          transform: translateY(0);\r\n        }\r\n      }\r\n\r\n      @keyframes fadeInScale {\r\n        from {\r\n          opacity: 0;\r\n          transform: scale(0.8);\r\n        }\r\n        to {\r\n          opacity: 1;\r\n          transform: scale(1);\r\n        }\r\n      }\r\n\r\n      .send-otp-btn {\r\n        width: 100%;\r\n        background: #1f2937;\r\n        color: white;\r\n        border: none;\r\n        padding: 16px;\r\n        border-radius: 8px;\r\n        font-size: 16px;\r\n        font-weight: 600;\r\n        cursor: pointer;\r\n        transition: background-color 0.2s ease;\r\n        min-height: 50px;\r\n\r\n        &:hover:not(:disabled) {\r\n          background: #111827;\r\n        }\r\n\r\n        &:disabled {\r\n          background: #cbd5e1;\r\n          cursor: not-allowed;\r\n        }\r\n      }\r\n\r\n      .auth-divider {\r\n        display: flex;\r\n        align-items: center;\r\n        color: #9ca3af;\r\n        font-size: 14px;\r\n        margin: 8px 0;\r\n\r\n        &::before,\r\n        &::after {\r\n          content: '';\r\n          flex: 1;\r\n          height: 1px;\r\n          background: #e5e7eb;\r\n        }\r\n\r\n        span {\r\n          padding: 0 16px;\r\n        }\r\n      }\r\n\r\n      .social-buttons {\r\n        display: flex;\r\n        justify-content: center;\r\n        gap: 20px;\r\n        width: 100%;\r\n\r\n        .social-btn {\r\n          flex: 1;\r\n          height: 52px;\r\n          border: 1px solid #d1d5db;\r\n          border-radius: 8px;\r\n          background: white;\r\n          cursor: pointer;\r\n          display: flex;\r\n          align-items: center;\r\n          justify-content: center;\r\n          gap: 10px;\r\n          transition: all 0.3s ease;\r\n          position: relative;\r\n          overflow: hidden;\r\n          font-size: 16px;\r\n          font-weight: 500;\r\n          color: #374151;\r\n\r\n          &:hover {\r\n            background-color: #f9fafb;\r\n          }\r\n\r\n          &::before {\r\n            content: '';\r\n            position: absolute;\r\n            top: 0;\r\n            left: -100%;\r\n            width: 100%;\r\n            height: 100%;\r\n            background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);\r\n            transition: left 0.5s ease;\r\n          }\r\n\r\n          &:hover::before {\r\n            left: 100%;\r\n          }\r\n\r\n          img {\r\n            width: 24px;\r\n            height: 24px;\r\n            transition: transform 0.3s ease;\r\n          }\r\n\r\n          &:hover img {\r\n            transform: scale(1.05);\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  // Tablet breakpoint (768px - 1024px)\r\n  @media (max-width: 1024px) {\r\n    .image-section {\r\n      width: 50%;\r\n\r\n      .carousel-text {\r\n        h1 {\r\n          font-size: 2.4rem;\r\n        }\r\n\r\n        p {\r\n          font-size: 1.1rem;\r\n        }\r\n      }\r\n    }\r\n\r\n    .form-section {\r\n      width: 50%;\r\n\r\n      .auth-form-content {\r\n        padding: 30px;\r\n      }\r\n\r\n      .form-title {\r\n        font-size: 24px;\r\n      }\r\n    }\r\n  }\r\n\r\n  // CRITICAL: Nest Hub and similar devices (1024x600)\r\n  @media (max-width: 1024px) and (max-height: 600px) {\r\n    .image-section {\r\n      width: 45%;\r\n\r\n      .carousel-text {\r\n        padding: 15px;\r\n\r\n        h1 {\r\n          font-size: 1.8rem;\r\n          margin-bottom: 8px;\r\n        }\r\n\r\n        p {\r\n          font-size: 0.95rem;\r\n          max-width: 400px;\r\n        }\r\n      }\r\n    }\r\n\r\n    .form-section {\r\n      width: 55%;\r\n\r\n      .main-logo-log {\r\n        padding: 15px 30px 10px;\r\n\r\n        .logo-dark-main-login {\r\n          height: 5vh;\r\n          min-height: 25px;\r\n          max-height: 40px;\r\n        }\r\n      }\r\n\r\n      .auth-form-content {\r\n        padding: 10px 30px 20px;\r\n      }\r\n\r\n      .form-title {\r\n        font-size: 20px;\r\n        margin-bottom: 12px;\r\n      }\r\n\r\n      .forgot-password {\r\n        margin-bottom: 16px;\r\n        font-size: 12px;\r\n      }\r\n\r\n      .mode-tabs {\r\n        margin-bottom: 20px;\r\n\r\n        .mode-tab {\r\n          padding: 10px 0;\r\n          font-size: 12px;\r\n        }\r\n      }\r\n\r\n      .auth-form {\r\n        gap: 16px;\r\n\r\n        .input-section {\r\n          .input-container {\r\n            min-height: 42px;\r\n\r\n            .country-code {\r\n              padding: 8px 12px;\r\n              font-size: 12px;\r\n            }\r\n\r\n            .input-field {\r\n              padding: 8px 12px;\r\n              font-size: 14px;\r\n            }\r\n\r\n            .edit-contact-btn {\r\n              padding: 6px;\r\n              \r\n              svg {\r\n                width: 16px;\r\n                height: 16px;\r\n              }\r\n            }\r\n\r\n            .resend-otp-btn {\r\n              font-size: 11px;\r\n              padding: 6px 10px;\r\n            }\r\n          }\r\n        }\r\n\r\n        .otp-input-section {\r\n          .otp-boxes {\r\n            .otp-input {\r\n              width: 38px;\r\n              height: 42px;\r\n              font-size: 16px;\r\n              max-width: 50px;\r\n            }\r\n          }\r\n        }\r\n\r\n        .send-otp-btn {\r\n          padding: 12px;\r\n          font-size: 14px;\r\n          min-height: 42px;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  // Mobile landscape and small tablets (768px)\r\n  @media (max-width: 850px) {\r\n    flex-direction: column;\r\n    height: 100vh;\r\n    max-height: 100vh;\r\n\r\n    .image-section {\r\n      width: 100%;\r\n      height: 40vh;\r\n      max-height: 40vh;\r\n      order: -1;\r\n      display: flex;\r\n      justify-content: center;\r\n      align-items: center;\r\n      flex-shrink: 0;\r\n\r\n      .carousel-text {\r\n        h1 {\r\n          font-size: 2rem;\r\n          margin-bottom: 8px;\r\n        }\r\n\r\n        p {\r\n          font-size: 1rem;\r\n          text-align: center;\r\n        }\r\n      }\r\n    }\r\n\r\n    .form-section {\r\n      width: 100%;\r\n      height: 60vh;\r\n      max-height: 60vh;\r\n      justify-content: flex-start;\r\n      padding-top: 0;\r\n      overflow-y: auto;\r\n\r\n      .main-logo-log {\r\n        padding: 15px 30px 8px;\r\n        flex-shrink: 0;\r\n\r\n        .logo-dark-main-login {\r\n          height: 5vh;\r\n          min-height: 30px;\r\n          max-height: 45px;\r\n        }\r\n      }\r\n\r\n      .auth-form-content {\r\n        padding: 8px 30px 20px;\r\n        flex: 1;\r\n        overflow-y: auto;\r\n      }\r\n\r\n      .form-title {\r\n        font-size: 22px;\r\n        margin-bottom: 12px;\r\n      }\r\n\r\n      .mode-tabs {\r\n        margin-bottom: 20px;\r\n\r\n        .mode-tab {\r\n          padding: 12px 0;\r\n          font-size: 13px;\r\n        }\r\n      }\r\n\r\n      .auth-form {\r\n        gap: 16px;\r\n\r\n        .input-section {\r\n          .input-container {\r\n            .edit-contact-btn {\r\n              padding: 7px;\r\n              \r\n              svg {\r\n                width: 17px;\r\n                height: 17px;\r\n              }\r\n            }\r\n\r\n            .resend-otp-btn {\r\n              font-size: 12px;\r\n              padding: 8px 12px;\r\n            }\r\n          }\r\n        }\r\n\r\n        .otp-input-section {\r\n          .otp-boxes {\r\n            .otp-input {\r\n              width: auto;\r\n              min-width: 40px;\r\n              max-width: none;\r\n              flex: 1;\r\n              height: 48px;\r\n              font-size: 16px;\r\n            }\r\n          }\r\n        }\r\n\r\n        .social-buttons {\r\n          flex-direction: column;\r\n          gap: 12px;\r\n\r\n          .social-btn {\r\n            height: 48px;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  // Mobile portrait (480px and below)\r\n  @media (max-width: 480px) {\r\n    .image-section {\r\n      height: 35vh;\r\n      max-height: 35vh;\r\n      min-height: 180px;\r\n\r\n      .carousel-text {\r\n        padding: 10px;\r\n        text-align: center;\r\n\r\n        h1 {\r\n          font-size: 1.6rem;\r\n          margin-bottom: 6px;\r\n        }\r\n\r\n        p {\r\n          font-size: 0.9rem;\r\n          max-width: 300px;\r\n        }\r\n      }\r\n    }\r\n\r\n    .form-section {\r\n      height: 65vh;\r\n      max-height: 65vh;\r\n\r\n      .main-logo-log {\r\n        padding: 10px 20px 5px;\r\n\r\n        .logo-dark-main-login {\r\n          height: 4vh;\r\n          min-height: 28px;\r\n          max-height: 40px;\r\n        }\r\n      }\r\n\r\n      .auth-form-content {\r\n        padding: 5px 20px 15px;\r\n      }\r\n\r\n      .form-title {\r\n        font-size: 20px;\r\n        margin-bottom: 10px;\r\n      }\r\n\r\n      .forgot-password {\r\n        margin-bottom: 14px;\r\n        font-size: 13px;\r\n      }\r\n\r\n      .mode-tabs {\r\n        margin-bottom: 16px;\r\n\r\n        .mode-tab {\r\n          padding: 10px 0;\r\n          font-size: 12px;\r\n        }\r\n      }\r\n\r\n      .auth-form {\r\n        gap: 14px;\r\n\r\n        .input-section {\r\n          .input-container {\r\n            min-height: 48px;\r\n\r\n            .country-code {\r\n              padding: 10px 12px;\r\n              min-width: 70px;\r\n              font-size: 13px;\r\n            }\r\n\r\n            .input-field {\r\n              padding: 10px 12px;\r\n              font-size: 16px;\r\n            }\r\n\r\n            .edit-contact-btn {\r\n              padding: 8px;\r\n              \r\n              svg {\r\n                width: 18px;\r\n                height: 18px;\r\n              }\r\n            }\r\n\r\n            .resend-otp-btn {\r\n              font-size: 11px;\r\n              padding: 6px 10px;\r\n            }\r\n          }\r\n        }\r\n\r\n        .otp-input-section {\r\n          .otp-boxes {\r\n            gap: 6px;\r\n\r\n            .otp-input {\r\n              height: 46px;\r\n              font-size: 16px;\r\n              min-width: 36px;\r\n            }\r\n          }\r\n        }\r\n\r\n        .send-otp-btn {\r\n          padding: 14px;\r\n          font-size: 15px;\r\n          min-height: 48px;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  // Extra small devices (320px and below)\r\n  @media (max-width: 320px) {\r\n    .image-section {\r\n      height: 30vh;\r\n      max-height: 30vh;\r\n      min-height: 150px;\r\n\r\n      .carousel-text {\r\n        h1 {\r\n          font-size: 1.4rem;\r\n        }\r\n\r\n        p {\r\n          font-size: 0.8rem;\r\n          max-width: 250px;\r\n        }\r\n      }\r\n    }\r\n\r\n    .form-section {\r\n      height: 70vh;\r\n      max-height: 70vh;\r\n\r\n      .main-logo-log {\r\n        padding: 8px 15px;\r\n\r\n        .logo-dark-main-login {\r\n          height: 3vh;\r\n          min-height: 24px;\r\n          max-height: 35px;\r\n        }\r\n      }\r\n\r\n      .auth-form-content {\r\n        padding: 4px 15px 12px;\r\n      }\r\n\r\n      .form-title {\r\n        font-size: 18px;\r\n        margin-bottom: 8px;\r\n      }\r\n\r\n      .auth-form {\r\n        gap: 12px;\r\n\r\n        .input-section {\r\n          .input-container {\r\n            .country-code {\r\n              padding: 8px 10px;\r\n              min-width: 65px;\r\n              font-size: 12px;\r\n            }\r\n\r\n            .input-field {\r\n              padding: 8px 10px;\r\n            }\r\n\r\n            .edit-contact-btn {\r\n              padding: 6px;\r\n              \r\n              svg {\r\n                width: 16px;\r\n                height: 16px;\r\n              }\r\n            }\r\n\r\n            .resend-otp-btn {\r\n              font-size: 10px;\r\n              padding: 5px 8px;\r\n            }\r\n          }\r\n        }\r\n\r\n        .otp-input-section {\r\n          .otp-boxes {\r\n            gap: 4px;\r\n\r\n            .otp-input {\r\n              min-width: 32px;\r\n              height: 44px;\r\n              font-size: 15px;\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  // High DPI displays\r\n  @media (-webkit-min-device-pixel-ratio: 2),\r\n  (min-resolution: 192dpi) {\r\n    .form-section {\r\n      .main-logo-log {\r\n        .logo-dark-main-login {\r\n          image-rendering: -webkit-optimize-contrast;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  // Dark mode support (if needed)\r\n  @media (prefers-color-scheme: dark) {\r\n    // Add dark mode styles if required\r\n  }\r\n\r\n  // Reduced motion preferences\r\n  @media (prefers-reduced-motion: reduce) {\r\n\r\n    *,\r\n    *::before,\r\n    *::after {\r\n      animation-duration: 0.01ms !important;\r\n      animation-iteration-count: 1 !important;\r\n      transition-duration: 0.01ms !important;\r\n    }\r\n  }\r\n\r\n  // Print styles\r\n  @media print {\r\n    .image-section {\r\n      display: none;\r\n    }\r\n\r\n    .form-section {\r\n      width: 100%;\r\n      box-shadow: none;\r\n      background: white;\r\n    }\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
